<ng-template #loading>
  <rma-skeleton-grid [bones]="1" heightClass="h-84" />
</ng-template>

<ng-container *transloco="let t; prefix: scope; loadingTpl: loading">
  <rma-comparison-table [heading]="t('title')">
    <rma-comparison-table-row [label]="t('agency')">
      @for (agent of agents(); track agent.agentCode) {
        <rma-comparison-table-cell>
          @if (agent.agencyName && agent.agencyProfileUrl) {
            <a [routerLink]="[agent.agencyProfileUrl]" data-id="overall-information-agency-link">{{ agent.agencyName }}</a>
          } @else {
            <span data-id="overall-information-agency-empty">&mdash;</span>
          }
        </rma-comparison-table-cell>
      }
    </rma-comparison-table-row>

    <rma-comparison-table-row [label]="t('reviews')">
      @for (agent of agents(); track agent.agentCode) {
        <rma-comparison-table-cell>
          @if (agent.overallStars; as overallStars) {
            <rma-icon aria-hidden="true" class="text-caution-50" [fill]="1" size="small" glyph="star" />
            <span class="pl-1 font-semibold">{{ overallStars }}</span>
          }
          @if (agent.reviewCount > 0) {
            <a class="pl-1" [routerLink]="[reviewsUrl(agent)]" data-id="overall-information-reviews-link">{{
              t('reviewCount', { count: (agent.reviewCount | number) })
            }}</a>
          } @else {
            <span class="pl-1" data-id="overall-information-reviews-count">{{ t('reviewCount', { count: agent.reviewCount }) }}</span>
          }
        </rma-comparison-table-cell>
      }
    </rma-comparison-table-row>

    @if (showSentiments()) {
      <rma-comparison-table-row [label]="t('sentiment')" data-id="overall-information-sentiment-row">
        @for (agent of agents(); track agent.agentCode) {
          <rma-comparison-table-cell>
            @if (agent.sentiments?.length) {
              <div class="flex flex-wrap justify-center gap-1" data-id="overall-information-sentiments">
                @for (sentiment of agent.sentiments.slice(0, maxSentimentPills); track sentiment) {
                  <span class="bg-blue-5 rounded-full px-2 py-0.5 text-xs" data-id="overall-information-sentiment-pill">{{
                    sentiment
                  }}</span>
                }
                @if (agent.sentiments.length > maxSentimentPills) {
                  <span class="bg-blue-5 rounded-full px-2 py-0.5 text-xs" data-id="overall-information-sentiment-more">{{
                    t('morePills', { count: agent.sentiments.length - maxSentimentPills })
                  }}</span>
                }
              </div>
            } @else {
              <span data-id="overall-information-sentiment-empty">&mdash;</span>
            }
          </rma-comparison-table-cell>
        }
      </rma-comparison-table-row>
    }

    @if (showLanguages()) {
      <rma-comparison-table-row [label]="t('languages')" data-id="overall-information-languages-row">
        @for (agent of agents(); track agent.agentCode) {
          <rma-comparison-table-cell>
            @if (agent.languages?.length) {
              <span *transloco="let tl; prefix: languageScope" data-id="overall-information-languages">
                @for (language of agent.languages; track language) {
                  @if (!$last) {
                    {{ tl(language) }},
                  } @else {
                    {{ tl(language) }}
                  }
                }
              </span>
            } @else {
              <span data-id="overall-information-languages-empty">&mdash;</span>
            }
          </rma-comparison-table-cell>
        }
      </rma-comparison-table-row>
    }

    @if (showAchievements()) {
      <rma-comparison-table-row [label]="t('achievements')" data-id="overall-information-achievements-row">
        @for (agent of agents(); track agent.agentCode) {
          <rma-comparison-table-cell>
            @if (agent.achievements?.length) {
              <div class="flex flex-wrap justify-center gap-2" data-id="overall-information-achievements">
                @for (achievement of agent.achievements; track achievement) {
                  <img
                    class="size-8 object-contain"
                    [attr.data-id]="'overall-information-achievement-' + achievement"
                    [src]="badgeImage[achievement] | staticAssetUrl"
                    [alt]="t('badges.' + achievement)"
                    [matTooltip]="t('badges.' + achievement)"
                    matTooltipPosition="above"
                    height="32"
                    width="32"
                  />
                }
              </div>
            } @else {
              <span data-id="overall-information-achievements-empty">&mdash;</span>
            }
          </rma-comparison-table-cell>
        }
      </rma-comparison-table-row>
    }
  </rma-comparison-table>
</ng-container>
